export default "__VITE_ASSET__DA3LUJVN__"